import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

// project imports
import NavItem from '../NavItem';

// assets
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

// ==============================|| SIDEBAR MENU LIST COLLAPSE ||============================== //

const NavCollapse = ({ menu, level }) => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const hasActiveChild = menu.children?.some((item) => item.url === pathname || pathname.startsWith(`${item.url}/`));
        if (hasActiveChild) setOpen(true);
    }, [pathname, menu.children]);

    const items = menu.children?.map((item) => {
        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={level + 1} />;
            case 'item':
                return <NavItem key={item.id} item={item} level={level + 1} />;
            default:
                return null;
        }
    });

    const Icon = menu.icon;

    return (
        <>
            <button
                type="button"
                className="gd-nav-item gd-nav-collapse__toggle"
                style={level > 1 ? { paddingLeft: `${level * 16}px` } : undefined}
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
            >
                {Icon && <Icon stroke={1.5} size={20} />}
                <span>{menu.title}</span>
                <span className="gd-nav-collapse__chevron">
                    {open ? <IconChevronUp stroke={1.5} size={16} /> : <IconChevronDown stroke={1.5} size={16} />}
                </span>
            </button>
            {open && <div>{items}</div>}
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;
